// useLanguage.js
export function useLanguage(locale,language) {

  // 获取 URL 参数设置语言
  console.log(language);
  if (typeof language === "string" && language.trim()) {
    locale.value = language.trim();
    localStorage.setItem("language", language.trim());
  } else {
    const savedLanguage = localStorage.getItem("language");
    if (savedLanguage) {
      locale.value = savedLanguage;
    }
  }
}
